module.exports = "<li :class=liClasses> <a :href=link> <icon v-if=iconValue :value=iconValue></icon> {{label}} <slot></slot> </a> </li>";


/*****************
 ** WEBPACK FOOTER
 ** ../~/vue-html-loader!../~/vue-loader/lib/selector.js?type=template&index=0!../~/material-ui-vue/components/pagination/pagination-item.vue
 ** module id = 342
 ** module chunks = 0
 **/